/**
 * Shipments CopilotKit Readable State
 */

import { useMemo } from 'react'
import { useCopilotReadable } from '@copilotkit/react-core'
import { useSelector } from '@spcc/core'
import { selectFilteredShipments, selectShipmentStats, selectSelectedShipment } from '../store/shipments.selectors'

export function useShipmentsReadable() {
  const shipments = useSelector(selectFilteredShipments)
  const stats = useSelector(selectShipmentStats)
  const selectedShipment = useSelector(selectSelectedShipment)

  const shipmentsValue = useMemo(() => shipments, [shipments])
  const statsValue = useMemo(() => stats, [stats])
  const selectedShipmentValue = useMemo(() => selectedShipment, [selectedShipment])

  useCopilotReadable({ description: 'Current shipments list', value: shipmentsValue })
  useCopilotReadable({ description: 'Shipment statistics', value: statsValue })
  useCopilotReadable({ description: 'Selected shipment details', value: selectedShipmentValue })
}
